const PageLines = () => {
  return (
    <div className="page-lines">
      <div className="container">
        <div className="col-line col-xs-4">
          <div className="line"></div>
        </div>
        <div className="col-line col-xs-4">
          <div className="line"></div>
        </div>
        <div className="col-line col-xs-4">
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </div>
  );
};

export default PageLines;
